import { Backdrop, Button, Chip, Fade, FormControl, InputLabel, MenuItem, Modal, OutlinedInput, Select, SelectChangeEvent, Stack, TextField } from "@mui/material";
import { useState } from "react";
import useLoading from "../../Hooks/useLoading";
import { toast } from "react-toastify";
import { PostNotification } from "../../API/FinepNotification";

interface IModalNotificationFinepProps {
    open: boolean,
    handleClose: () => void,
    emailsToSelect: string[],
    toggleLoading: (value: boolean) => void,
    registerId: string,
    cardName: string,
    tabName: string,

}

const ModalNotificationFinep = (props: IModalNotificationFinepProps) => {

    const [email, setEmail] = useState<string[]>([]);
    const [bodyMessage, setBodyMessage] = useState<string>("");

    const handleChange = (event: SelectChangeEvent<typeof email>) => {
        const {
            target: { value },
        } = event;
        setEmail(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    const clearFields = () => {
        setEmail([]);
        setBodyMessage("");
    }

    const sendNotification = async () => {
        try {
            props.toggleLoading(true);
            props.handleClose();

            await PostNotification(props.registerId, props.cardName, props.tabName, bodyMessage, email);

        } catch (error: any) {
            toast.error(error);
        } finally {
            props.toggleLoading(false);
            clearFields();
        }
    }


    return (
        <Modal
            open={props.open}
            onClose={() => { clearFields(); props.handleClose() }}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
            className="d-flex align-items-center justify-content-center"
        >
            <Fade in={props.open}>
                <div className="card p-4 w-50">
                    <h2>Notificar Campos Pendentes</h2>
                    <div className="mt-4 h-100">
                        <FormControl className="w-100">
                            <InputLabel id="labelId">Selecione</InputLabel>
                            <Select
                                multiple
                                labelId="labelId"
                                className="w-100"
                                label="Selecione"
                                value={email}
                                onChange={handleChange}
                                input={<OutlinedInput label="Multiple Select" />}
                                renderValue={(selected) => (
                                    <Stack gap={1} direction="row" flexWrap="wrap">
                                        {selected.map((value) => (
                                            <Chip key={value} label={value} />
                                        ))}
                                    </Stack>
                                )}
                            >
                                {props.emailsToSelect.map((emailsToSelect, index) => {
                                    return (
                                        <MenuItem key={index} value={emailsToSelect}>{emailsToSelect}</MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>
                        <TextField
                            type="text"
                            multiline
                            rows={3}
                            label="Mensagem a ser enviada"
                            className="w-100 h-100 mt-3"
                            value={bodyMessage}
                            onChange={e => setBodyMessage(e.target.value)}
                        />
                        <div className="mt-4 d-flex aling-items-center justify-content-end w-100">
                            <Button variant="outlined" color="inherit" className="me-2" onClick={() => { clearFields(); props.handleClose() }}>Cancelar</Button>
                            <Button disabled={email.length == 0 || bodyMessage == ""} onClick={sendNotification} variant="contained" color="primary" className="ms-2">Enviar</Button>
                        </div>
                    </div>
                </div>
            </Fade>
        </Modal>
    )
}

export default ModalNotificationFinep;